import React from "react";
import { useNavigate } from "react-router-dom";
//import school from "../assets/school.jpg";
import faculty from "../assets/facility.jpg";
import history from"../assets/school_image.png";

const HomeAbout = () => {
  const navigate = useNavigate();

  return (
    <div className="home-about">

      <div className="home-about-overlay">

        <div className="container">

          <h2>
            ABOUT <span>NAV JEVAN MISSION INTERNATIONAL SCHOOL</span>
          </h2>

          <p>Nav Jeevan Mission International School, Gorakhpur, is committed to 
            providing quality education in a nurturing and disciplined environment.....
          </p>

          {/* MAIN BUTTON */}
          <button onClick={() => navigate("/about")}>
            READ MORE
          </button>

          {/* CARDS */}
          <div className="about-cards">

            <div
              className="about-card"
              onClick={() => navigate("/about?tab=history")}
            >

              <img src={history} alt="history" />

              <div>
                <h3>Origin & History</h3>
                <button>READ MORE</button>
              </div>

            </div>

            <div
              className="about-card"
              onClick={() => navigate("/about?tab=faculty")}
            >

              <img src={faculty} alt="faculty" />

              <div>
                <h3>FACULTY & STAFFS</h3>
                <button>READ MORE</button>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default HomeAbout;